import slugify from "slugify";

export default function slugifyFacade(input: string): string {
  return slugify(input, {
    lower: true,
    replacement: "-",
    remove: new RegExp(/[*+~.()'"!:@?]/g),
  });
}
